import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'mediaPlay',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-media-play wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g class="wd-icon-container"><path fill-rule="evenodd" d="M7 4.895a.5.5 0 0 1 .762-.426l11.546 7.105a.5.5 0 0 1 0 .852L7.762 19.53A.5.5 0 0 1 7 19.105z" class="wd-icon-fill" clip-rule="evenodd"/></g></svg>',
    filename: 'wd-icon-media-play.svg',
    category: 'Learning',
    tags: ['play', 'triangle', 'video'],
};
export default icon;
